import { createApp, ref } from 'vue'
import { AstraPlugin, defineOrugaBulmaConfig } from '@platform/astra-vue'
import { OrugaConfig, Collapse /*, OCollapse*/ } from '@oruga-ui/oruga-next'

/**
 * Простой помощник для вывода сообщений в консоль браузера при разработке.
 */
// import { devLog } from '../utils'

/**
 * Экспорт функции - правильный и более гибкий подход. Функция может
 * содержать любую логику и вызываться в необходимое время. Для
 * битрикс обычно это глобальная функция инициализации в main.ts
 */
export const createCollapseAccordion = () => {
  // devLog('astra-collapse:create')

  try {
    createAstraCollapseAccordion()
  } catch (e) {
    // console.log(e)
  }
}

function createAstraCollapseAccordion () {
  if (!document.querySelector('.astra-collapse-accordion')) {
    // devLog('WARN! .astra-collapse-accordion not found')
    return null
  }

  /**
   * Любое Vue приложение надо создавать, и добавлять
   * к нему необходимые компоненты и функции. Глобально экземпляра нет.
   *
   * Библиотеки при этом для "бандла" будут использованы одни. Но
   * только если приложение будет создавать в общем  потоке сборки.
   */
  createApp({
    /**
     * mounted - это хук жизненного цикла Vue и вызывается
     * уже после готовности DOM. Может сложиться ситуация, при использовании
     * DOMContentLoaded, когда приложение не будет работать. Надо внимательно
     * контролировать жизненный цикл приложения.
     *
     */
    mounted() {
      /**
       * Здесь можно использовать функции клиента.
       */
      // devLog(`astra-collapse:mounted ${this.active}`)
    },
    /**
     *
     * Основная функция инициализации, установки Vue приложения.
     * Здесь определяются переменные и функции, состояния.
     */
    setup() {
      // devLog('astra-collapse:setup')
      /**
       * Хранит индекс активного блока. Обычно переменные нужны
       * для динамических "конструкций", например, создание "аккордеона"
       * из нескольких `o-collapse`.
       */
      const active = ref()

      return {
        active
      }
    }
  })
    /**
     * Конфигурация и настройки Bulma для Oruga,
     * поставляемые пакетом @platform/astra-vue.
     *
     * Можно создать по примеру собственную конфигурацию
     * сайта, если по каким-то причинам эта не работает.
     */
    .use(OrugaConfig, { ...defineOrugaBulmaConfig })
    /**
     * Плагин Oruga Oruga Collapse, он включает компонент.
     */
    .use(Collapse)
    /**
     * Подключение набора компонентов, если необходимо.
     */
    .use(AstraPlugin, {})
    /**
     * Точка монтирования. Если создается полностью Vue приложение,
     * то используется отдельный SFC компонент, например `createApp(MyCollapse)`.
     * Но в битрикс довольно часто используется уже существующий HTML-код
     * в качестве шаблона компонента. Чтобы такой подход работал в Vite
     * указана настройка, псевдоним на библиотеку Vue включающую runtime-compiler.
     * Это медленнее, отрисовка только на клиенте, но более правильно в битрикс,
     * с точки зрения индексации. Найти баланс трудно. Пока так.
     *
     * Vue монтирует приложение, обертывая HTML-код отдельным div элементом,
     * это надо учитывать.
     *
     * Код шаблона и все компоненты должны находиться в элементе
     * `#astra-collapse-demo`. Да это немного криво и не так изящно как SFC.
     * Но выбора нет.
     *
     * Можно создать универсальную функцию монтирования для классов и т.п.
     * Если конечно есть потребность
     *
     */
    .mount('.astra-collapse-accordion')
}
